import { all, takeEvery, put, call, fork } from 'redux-saga/effects';
import LogApi from '../../library/helpers/logsHelper';
import { notification } from '@iso/components';
import actions from './action';

export function* LogRead() {
    yield takeEvery(actions.LOG_LIST_READ, function* ({ payload }) {
      try {
        const searchResult = yield call(LogApi.readLogs, payload.readFilter,payload.page);
        if (searchResult.success) {
          yield put(
            actions.logReadSearchSuccess(
              searchResult.data.result,
              searchResult.succses,
              searchResult.data.totalCount,
              payload.page
            )
          );
        } else {
          notification('error', searchResult.message);
        yield put(
          actions.logReadSearchSuccess({}, false, 0, 0)
        );
        }
      } catch (error) {
        console.log("Error::::::::::::::", error);
      }
    });
  }
  export default function* rootSaga() {
    yield all([
      fork(LogRead),
    ]);
  }

